import { useEffect, useState } from "react";
import { apiFetch } from "../../components/helpers";

export default function CreateAppointment() {
  const [doctors, setDoctors] = useState([]);
  const [patients, setPatients] = useState([]);
  const [search, setSearch] = useState("");
  const [selectedPatient, setSelectedPatient] = useState(null);
  const [form, setForm] = useState({
    name: "",
    mobile: "",
    email: "",
    address: "",
  });
  const now = new Date();

const currentDate = now.toISOString().split("T")[0];

const currentTime =
  String(now.getHours()).padStart(2, "0") +
  ":" +
  String(now.getMinutes()).padStart(2, "0");

const [book, setBook] = useState({
  doctor_id: "",
  appointment_date: currentDate,
  appointment_time: currentTime,
  notes: "",
});
  const [msg, setMsg] = useState("");
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    loadDoctors();
  }, []);
  const loadDoctors = async () => {
    const r = await apiFetch(process.env.REACT_APP_GET_ALL_DOCTORS);
    if (r.status) setDoctors(r.data || []);
  };
  const searchPatients = async (v) => {
    setSearch(v);
    if (!v) return setPatients([]);
    const r = await apiFetch(
      `${process.env.REACT_APP_SEARCH_PATIENT}?search=${encodeURIComponent(v)}`,
    );
    setPatients(r.data || []);
  };
  const addPatient = async () => {
    const r = await apiFetch(process.env.REACT_APP_REGISTER_PATIENT, {
      method: "POST",
      body: form,
    });
    if (r.status) {
      setMsg("Patient added");
      searchPatients(form.mobile);
    }
  };
  const bookNow = async () => {
  try {
    const patient_id = selectedPatient?.patient_id;

    const payload = {
      ...book,
      patient_id,
      appointment_date: book.appointment_date,
      appointment_time: book.appointment_time + ":00",
    };

    const r = await apiFetch(
      process.env.REACT_APP_CREATE_APPOINTMENT,
      {
        method: "POST",
        body: payload,
      }
    );

    setMsg(r.message || "Done");

  } catch (e) {
    console.log(e);
    setMsg("Something went wrong");
  }
};
  return (
    <div className="p-4">
      <h2>Create Appointment</h2>
      {msg && <div className="alert alert-info">{msg}</div>}
      <div className="card p-3 mb-3">
        <h5>1. Search Patient</h5>
        <input
          className="form-control mb-2"
          placeholder="ID / Name / Mobile / Email"
          value={search}
          onChange={(e) => searchPatients(e.target.value)}
        />
        {patients.map((p) => (
          <div
            key={p.patient_id}
            className="border p-2 mb-1 d-flex justify-content-between"
          >
            <span>
              {p.name} ({p.mobile})
            </span>
            <button
              className="btn btn-sm btn-primary"
              onClick={() => setSelectedPatient(p)}
            >
              Select
            </button>
          </div>
        ))}
        {!patients.length && search && (
          <div className="mt-2">
            <h6>Not found? Add Patient</h6>
            <input
              className="form-control mb-2"
              placeholder="Name"
              onChange={(e) => setForm({ ...form, name: e.target.value })}
            />
            <input
              className="form-control mb-2"
              placeholder="Mobile"
              onChange={(e) => setForm({ ...form, mobile: e.target.value })}
            />
            <input
              className="form-control mb-2"
              placeholder="Email"
              onChange={(e) => setForm({ ...form, email: e.target.value })}
            />
            <input
              className="form-control mb-2"
              placeholder="Address"
              onChange={(e) => setForm({ ...form, address: e.target.value })}
            />
            <button className="btn btn-success" onClick={addPatient}>
              Create Patient
            </button>
          </div>
        )}
      </div>
      <div className="card p-3">
        <h5>2. Book Appointment</h5>
        <div className="mb-2">
          Selected Patient: {selectedPatient ? selectedPatient.name : "None"}
        </div>
        <select
          className="form-select mb-2"
          onChange={(e) => setBook({ ...book, doctor_id: e.target.value })}
        >
          <option value="">Select Doctor</option>
          {doctors.map((d) => (
            <option key={d.doctor_id} value={d.doctor_id}>
              {d.name}
            </option>
          ))}
        </select>
        <input
          type="date"
          value={book.appointment_date}
          className="form-control mb-2"
          onChange={(e) =>
            setBook({ ...book, appointment_date: e.target.value })
          }
        />
        <input
          type="time"
          className="form-control mb-2"
          value={book.appointment_time}
          onChange={(e) =>
            setBook({ ...book, appointment_time: e.target.value })
          }
        />
        <textarea
          className="form-control mb-2"
          placeholder="Notes"
          onChange={(e) => setBook({ ...book, notes: e.target.value })}
        ></textarea>
        <button
          className="btn btn-primary"
          disabled={!selectedPatient}
          onClick={bookNow}
        >
          Book Appointment
        </button>
      </div>
    </div>
  );
}
